
export const getError = (error) => {
    return error.response && error.response.data.message
      ? error.response.data.message
      : error.message;
  };
  
  // Example usage in another component

  // const exampleFunction = async () => {
  //   try {
  //     // Some code that might throw an error
  //   } catch (error) {
  //     const errorMessage = getError(error);
  //     console.error(errorMessage);
  //   }
  // };